/**
 * @generated SignedSource<<62ada6a822569bac9dedc5d35380f458>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AgeRange = "LT12" | "GT12LT19" | "GT20LT24" | "GT25LT29" | "GT30LT34" | "GT35LT39" | "GT40LT44" | "GT45LT49" | "GT50LT54" | "GT55LT59" | "%future added value";
export type Browser = "IE" | "CHROME" | "SAFARI" | "FIREFOX" | "EDGE" | "OTHER" | "%future added value";
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type Gender = "MALE" | "FEMALE" | "%future added value";
export type MatchOp = "EQUAL" | "CONTAINS" | "%future added value";
export type Platform = "IOS" | "WINDOWS" | "ANDROID" | "MAC" | "LINUX" | "OTHER" | "%future added value";
export type VisitMatch = "EQUAL_MATCH_TYPE" | "OVER_MATCH_TYPE" | "UNDER_MATCH_TYPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChatbotEditScreenContainer_chatbotGroup$data = {
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly page: {
    readonly id: string;
    readonly funnel: {
      readonly id: string;
    };
  };
  readonly browsers: ReadonlyArray<Browser>;
  readonly devices: ReadonlyArray<Device>;
  readonly genders: ReadonlyArray<Gender>;
  readonly ageRanges: ReadonlyArray<AgeRange>;
  readonly deliverKind: DeliverKind;
  readonly platforms: ReadonlyArray<Platform>;
  readonly repeat: boolean;
  readonly startDate: string | null;
  readonly startTime: string | null;
  readonly endDate: string | null;
  readonly endTime: string | null;
  readonly status: DistributionStatus;
  readonly sources: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly excludeReferrers: ReadonlyArray<{
    readonly referrer: string;
    readonly matchOp: MatchOp;
  }>;
  readonly referrers: ReadonlyArray<{
    readonly referrer: string;
    readonly matchOp: MatchOp;
  }>;
  readonly visitCount: number | null;
  readonly visitMatchType: VisitMatch;
  readonly deliverTargetUrls: ReadonlyArray<{
    readonly url: string;
  }>;
  readonly deliverExcludeUrls: ReadonlyArray<{
    readonly url: string;
  }>;
  readonly targetCookies: ReadonlyArray<{
    readonly key: string;
    readonly value: string;
    readonly matchType: boolean;
  }>;
  readonly deliverDayOfWeeks: ReadonlyArray<{
    readonly weekOfMonth: number | null;
    readonly daysOfWeek: ReadonlyArray<DayOfWeek>;
  }>;
  readonly " $fragmentType": "ChatbotEditScreenContainer_chatbotGroup";
};
export type ChatbotEditScreenContainer_chatbotGroup = ChatbotEditScreenContainer_chatbotGroup$data;
export type ChatbotEditScreenContainer_chatbotGroup$key = {
  readonly " $data"?: ChatbotEditScreenContainer_chatbotGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatbotEditScreenContainer_chatbotGroup">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "referrer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchOp",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatbotEditScreenContainer_chatbotGroup",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Page",
      "kind": "LinkedField",
      "name": "page",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Funnel",
          "kind": "LinkedField",
          "name": "funnel",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "devices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "genders",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ageRanges",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deliverKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platforms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Source",
      "kind": "LinkedField",
      "name": "sources",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupExcludeReferrer",
      "kind": "LinkedField",
      "name": "excludeReferrers",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupReferrer",
      "kind": "LinkedField",
      "name": "referrers",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitMatchType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupDeliverTargetUrl",
      "kind": "LinkedField",
      "name": "deliverTargetUrls",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupDeliverExcludeUrl",
      "kind": "LinkedField",
      "name": "deliverExcludeUrls",
      "plural": true,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatbotGroupTargetCookie",
      "kind": "LinkedField",
      "name": "targetCookies",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "matchType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DeliverDayOfWeek",
      "kind": "LinkedField",
      "name": "deliverDayOfWeeks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekOfMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "daysOfWeek",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatbotGroup",
  "abstractKey": null
};
})();

(node as any).hash = "9a5080ad9ace66c8cb8f8865f641a6a2";

export default node;
